export default __webpack_public_path__ + "11a3c6e06815348824c559860d496bde.jpg";